// Preset packs use single variants so Shopify owns pricing and stock validation.
document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-fw-preset-add]') : null;
  if (!button || button.disabled) return;
  const root = button.closest('[data-fw-preset]');
  const errorEl = root.querySelector('[data-fw-preset-error]');
  const label = button.innerHTML;
  const base = window.Shopify?.routes?.root || '/';
  button.disabled = true;
  button.textContent = 'Adding…';
  errorEl.hidden = true;
  let attempted = false;
  try {
    const chosen = new Map();
    root.querySelectorAll('[data-fw-preset-components] [data-id]').forEach(el => {
      const id = el.dataset.id;
      if (!id) throw new Error('This kit is currently unavailable.');
      const maximum = el.dataset.max === '' ? Infinity : Number(el.dataset.max);
      const item = chosen.get(id) || { id, quantity: 0, maximum };
      item.quantity++;
      chosen.set(id, item);
    });
    if (!chosen.size) throw new Error('This kit is currently unavailable.');
    const response = await fetch(base + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Your cart could not be checked. Please try again.');
    const cart = await response.json();
    const eligible = new Set([...root.querySelectorAll('[data-fw-preset-eligible] [data-id]')].map(el => el.dataset.id));
    const count = cart.items.reduce((sum, item) => sum + (eligible.has(String(item.variant_id)) && !item.selling_plan_allocation ? item.quantity : 0), 0);
    const adding = [...chosen.values()].reduce((sum, item) => sum + item.quantity, 0);
    if (count + adding > 12) throw new Error('Bundle pricing supports up to 12 single kits per cart. Contact us for a larger order.');
    for (const item of chosen.values()) {
      const already = cart.items.filter(line => String(line.variant_id) === item.id).reduce((sum, line) => sum + line.quantity, 0);
      if (already + item.quantity > item.maximum) throw new Error('There is not enough stock for this set. Please review your cart.');
    }
    attempted = true;
    const added = await fetch(base + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [...chosen.values()].map(({id, quantity}) => ({id, quantity})) })
    });
    if (!added.ok) throw new Error('The full addition could not be confirmed. Review your cart before trying again.');
    window.location.assign(base + 'cart');
  } catch (error) {
    errorEl.textContent = error.message;
    const link = document.createElement('a');
    link.href = base + 'cart';
    link.textContent = 'View cart';
    errorEl.append(' ', link);
    errorEl.hidden = false;
    button.innerHTML = label;
    button.disabled = attempted;
  }
});

const enablePresetButtons = (scope = document) => scope.querySelectorAll('[data-fw-preset-add]:not([data-ready])').forEach(button => {
  button.dataset.ready = 'true';
  button.disabled = button.dataset.available !== 'true';
});
enablePresetButtons();
document.addEventListener('shopify:section:load', event => enablePresetButtons(event.target));
